import * as React from 'react'
import {
  GridToolbarContainer,
  GridToolbarContainerProps,
  GridToolbarDensitySelector,
  selectedGridRowsCountSelector,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from '@mui/x-data-grid-pro'

import GridColumnsSelectorButton, {
  isSelectorSlotProps,
} from './GridColumnsSelector'

import GridExportButton from './GridExportButton'
import { BulkActions, BulkActionsToolbar } from '../BulkActions'
import { useDisableColumnSort } from './hooks'
import {
  GridFilter,
  GridFilterProps,
} from '@user/components/xGrid/atoms/GridCustomToolbar/GridFilter/GridFilter'

type Props = GridToolbarContainerProps & {
  disableInteraction?: boolean
  BulkActions?: BulkActions
  exportClickCallback: () => void
  isDensityEnable: boolean
  isExportEnable: boolean
  hideDefaultBtn?: boolean
  isFilterEnable?: boolean
  gridFilterProps?: GridFilterProps<any>
  exportFileName?: string
}

export function GridCustomToolbar(props: Props) {
  const {
    disableInteraction = false,
    BulkActions,
    exportClickCallback,
    isDensityEnable,
    isExportEnable,
    hideDefaultBtn = false,
    isFilterEnable = false,
    gridFilterProps,
    exportFileName,
    ...rest
  } = props
  const apiRef = useGridApiContext()

  useDisableColumnSort(apiRef)

  const selectionCount = useGridSelector(apiRef, selectedGridRowsCountSelector)

  const { slotProps } = useGridRootProps()

  const columnSelectorProps = React.useMemo(() => {
    if (slotProps)
      if (isSelectorSlotProps(slotProps.columnsPanel))
        return slotProps.columnsPanel
  }, [slotProps])

  return (
    <GridToolbarContainer {...rest}>
      {selectionCount > 0 && BulkActions ? (
        <BulkActionsToolbar apiRef={apiRef} BulkActions={BulkActions} />
      ) : columnSelectorProps ? (
        <GridColumnsSelectorButton
          apiRef={apiRef}
          {...columnSelectorProps}
          disableInteraction={disableInteraction}
          hideDefaultBtn={hideDefaultBtn}
        />
      ) : null}

      {isFilterEnable && gridFilterProps && (
        <GridFilter
          disableInteraction={disableInteraction}
          {...gridFilterProps}
        />
      )}
      {isDensityEnable && (
        <GridToolbarDensitySelector
          size="medium"
          disabled={disableInteraction}
        />
      )}
      {isExportEnable && (
        <GridExportButton
          disableInteraction={disableInteraction}
          exportClickCallback={exportClickCallback}
          apiRef={apiRef}
          exportFileName={exportFileName}
        />
      )}
    </GridToolbarContainer>
  )
}
